module.exports = __webpack_public_path__ + "07c46208cfb3da2715b26f3441a96356.svg";